import { render, staticRenderFns } from "./complaintsChart.vue?vue&type=template&id=f96bf9c4&"
import script from "./complaintsChart.vue?vue&type=script&lang=js&"
export * from "./complaintsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f96bf9c4')) {
      api.createRecord('f96bf9c4', component.options)
    } else {
      api.reload('f96bf9c4', component.options)
    }
    module.hot.accept("./complaintsChart.vue?vue&type=template&id=f96bf9c4&", function () {
      api.rerender('f96bf9c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/zhlg/components/complaintsChart.vue"
export default component.exports